import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const StageActions = (props) => {
    const classNames = classnames('stage-actions', {
        'stage-actions--full': props.full
    }, props.className);

    return (
        <div className={classNames}>
            {
                props.full ?
                    <div className="stage-actions__panel">
                        {props.full}
                        <div className="u-clearer"></div>
                    </div> : null
            }

            <div className="stage-actions__panel stage-actions__panel--left">
                {props.left}
                <div className="u-clearer"></div>
            </div>

            <div className="stage-actions__panel stage-actions__panel--right">
                {props.right}
                <div className="u-clearer"></div>
            </div>
            <div className="u-clearer"></div>
        </div>
    );
};

StageActions.propTypes = {
    className: PropTypes.string,
    left: PropTypes.node,
    right: PropTypes.node
};

export default StageActions;